import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ZevaPageSelector } from '../core/core.models';
import { ZEVA_PAGES } from '../core/core.static';
import { AnalyticsComponent } from './analytics.component';

const analyticsRoutes: Routes = [
  {
    path: '',
    component: AnalyticsComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ZEVA_PAGES[ZevaPageSelector.ANALYTICS_VEHICLE].slug,
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/vehicle/vehicle-analytics.module').then(m => m.VehicleAnalyticsModule),
        data: { title: ZEVA_PAGES[ZevaPageSelector.ANALYTICS_VEHICLE].name },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(analyticsRoutes)],
  exports: [RouterModule],
})
export class AnalyticsRoutingModule {}
